// extracted by mini-css-extract-plugin
export default {"range-datepicker":"dateRangePickerCalendar_range-datepicker__9LCqI","mobile":"dateRangePickerCalendar_mobile__VlMKC"};